import Options from '@utils/common/options/module'
const options = new Options('options')
  .add(1, 'billStatus[0]')
  .add(2, 'billStatus[1]')
  .add(3, 'billStatus[2]')
  .add(4, 'billStatus[3]')
  .add(5, 'billStatus[4]')
  .add(6, 'billStatus[5]')

export default options

